


























import {
    defineComponent,
    computed,
    ref,
    watch,
    onMounted,
    nextTick
} from "@vue/composition-api";
import { Chart, ChartItem, registerables, LineController, TimeUnit } from "chart.js";
import "date-fns";
import "chartjs-adapter-date-fns";
import useBatteryStatistik, { BatteryDataPoint } from "@/store/useBatteryStatistic";
Chart.register(...registerables);

export default defineComponent({
    props: {
        imgSrc: { type: String },
        value: { type: Boolean, default: false },
        deviceType: { type: Number, default: 0 },
        id: { type: String, required: true },
        subtitle: { type: String, default: "" }
    },
    setup(props, context) {
        const chartCanvas = ref<HTMLCanvasElement>();
        const toggle_chart = ref<number>(0);
        let interval: number = 7;
        const { getBatteryData, batteryData } = useBatteryStatistik();
        let chart: any = null;

        onMounted(() => {
            setupChart();
        });

        const setupChart = () => {
            const ctx = chartCanvas.value as ChartItem;
            if (!ctx) return;

            getBatteryData(props.id, interval).then(
                (data: Array<BatteryDataPoint>) => {
                    let scale: TimeUnit = "day";
                    let titleText = "Charge level"
                    switch (toggle_chart.value) {
                        case 0:
                            scale = "day";
                            titleText = "Daily charge level (7 Days)"
                            break;
                        case 1:
                            scale = "day";
                            titleText = "Daily charge level (30 Days)"
                            break;
                        case 2:
                            scale = "week";
                            titleText = "Weekly charge level (90 Days)"
                            break;
                        case 3:
                            scale = "month";
                            titleText = "Monthly charge level (365 Days)"
                            break;
                    }

                    chart = new Chart(ctx, {
                        type: "line",
                        data: {
                            datasets: [
                                {
                                    label: "Voltage",
                                    data: data,
                                    fill: true,
                                    borderColor: "rgb(75, 192, 192)",
                                    tension: 0.1
                                }
                            ],
                        } as any, // Set chart data type as any
                        options: {
                            plugins: {
                                title: {
                                    display: true,
                                    text: titleText,
                                    align: "center",
                                    position: "top",
                                    padding: {
                                        top: 10,
                                        bottom: 10
                                    }
                                },
                                subtitle: {
                                    display: true,
                                    text: props.subtitle,
                                    align: "center",
                                    padding: {
                                        bottom: 10,
                                    }
                                },
                                legend: {
                                    display: false
                                }
                            },
                            elements: {
                                point: {
                                    radius: 9,
                                    hitRadius: 3,
                                    hoverRadius: 12
                                }
                            },
                            parsing: {
                                xAxisKey: "date",
                                yAxisKey: "voltage"
                            },
                            scales: {
                                x: {
                                    title: {
                                        display: false,
                                        text: "Date"
                                    },
                                    type: "time",
                                    time: {
                                        unit: scale,
                                        displayFormats: {
                                            day: "dd-MMM",
                                            week: "dd-MMM",
                                            month: "MMM yyyy",
                                            quarter: "MMM yyyy",
                                            year: "yyyy",
                                        },
                                    },
                                },
                                y: {
                                    title: {
                                        display: true,
                                        text: "Voltage"
                                    }
                                }
                            }
                        }
                    });

                    // Set different widths for the chart based on toggle_chart.value
                    const canvas = chart.canvas as HTMLCanvasElement;
                    switch (toggle_chart.value) {
                       case 0:
                            canvas.style.width = "auto";
                            break;
                        case 1:
                            canvas.style.width = "auto";
                            break;
                        case 2:
                            canvas.style.width = "auto";
                            break;
                        case 3:
                            canvas.style.width = "auto";
                            break;
                    }
                }
            );
        };

        const dialog = computed(() => {
            return props.value;
        });

        const close = () => {
            if (chart) {
                chart.destroy();
            }
            context.emit("input", false);
        };

        watch( 
            () => props.value,
            () => {
                if (props.value) {
                    nextTick().then(() => {
                        setupChart();
                    });
                } 
            }
        );

        watch(
            () => toggle_chart.value,
            value => {
                switch (value) {
                    case 0:
                        interval = 7;
                        break;
                    case 1:
                        interval = 30;
                        break;
                    case 2:
                        interval = 90;
                        break;
                    case 3:
                        interval = 365;
                        break;
                }
                if (chart) {
                    chart.destroy();
                }
                nextTick().then(() => {
                    setupChart();
                });
            }
        );

        return {
            dialog,
            close,
            chartCanvas,
            toggle_chart
        };
    }
});
